import { render, staticRenderFns } from "./ordersettingaction.vue?vue&type=template&id=696a9d26&scoped=true&"
import script from "./ordersettingaction.vue?vue&type=script&lang=js&"
export * from "./ordersettingaction.vue?vue&type=script&lang=js&"
import style0 from "./ordersettingaction.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ordersettingaction.vue?vue&type=style&index=1&id=696a9d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a9d26",
  null
  
)

export default component.exports